import React from 'react'
import "../styles/style.css"
function Landing() {
    return (
        <div className='landing_page'>
            <div class="bg-image"></div>
            <div className="text">
                <h1>Kissania</h1>
                <h4>A favour to our foodgods.</h4>
                <div className="wrapper">
                    <a className='primary-button' href='https://wingzacademy.com/kissania/' target="_blank" >Buy Farming Products</a>
                </div>
            </div>
        </div>
    )
}

export default Landing